import React, { useEffect, useState } from "react";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import candidateLogin, { saveUserDetails } from "../../services/AuthService";
import uiConfig from "../../helpers/Firebase";
import { ProfileService } from "../../services/ProfileService";
import Header from "../nav/header";
import { APIResposneService } from "../../services/APIResponseService";
import PhoneNumber from "libphonenumber-js"
import { Stringutility } from "../../utilities/stringutility";
import { StorageValues } from "../../constants/storageValues";
import { StorageService } from "../../services/StorageService";
import { GenericCodes } from "../../constants/genericCodeValues";


const Firebaselogin = () => {
  const [isSignedIn, setIsSignedIn] = useState(false); // Local signed-in state.
  const [accept_terms_and_conditions, setAcceptTermsConditions] =
    useState(true);
  const [accept_privacy_policy, setAcceptPrivacyPolicy] = useState(true);
  const [idToken, setIdToken] = useState("");

  useEffect(() => {
    if (window.localStorage.getItem("user") == null) {
      const unregisterAuthObserver = firebase
        .auth()
        .onAuthStateChanged((user) => {
          setIsSignedIn(!!user);
          if (user) {
            firebase
              .auth()
              .currentUser.getIdToken(/* forceRefresh */ true)
              .then(function (idToken) {
                setIdToken(idToken);

                APIResposneService.saveAuthToken(idToken);
                APIResposneService.saveFireBaseAuthResponse(user);

                var phoneNo = Stringutility.getValue(user.phoneNumber);
                var countryCode = "";
                var phoneNumber = "";
                if (!Stringutility.isNullOrEmpty(phoneNo)) {
                  const phoneNumberObj = PhoneNumber(user.phoneNumber);
                  countryCode = phoneNumberObj.countryCallingCode;
                  phoneNumber = phoneNumberObj.nationalNumber;
                }
                var email = Stringutility.getValue(user.email);
                var firstName = "";
                var lastName = "";

                if (user.displayName !== null) {
                  const fullName = user.displayName.split(" ");
                  firstName = Stringutility.getValue(fullName[0]);
                  lastName = Stringutility.getValue(fullName[1]);
                }

                document.body.classList.add("loading-indicator");
                candidateLogin()
                  .then((response) => {
                    document.body.classList.remove("loading-indicator");                 
                    StorageService.saveInSessionStorage(StorageValues.APPLY_JOB,"clickapplybutton");
                    if (
                      response.data.failure_code === GenericCodes.accountDoesNotExist
                    ) {
                      const reqObj = {
                        phoneNumber: phoneNumber,
                        countryCode: countryCode,
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                      };
                      submitButton(reqObj);
                    } else {
                      if (response.data !== undefined && response.data !== "") {
                        const loginResposne = response.data;
                        APIResposneService.saveLoginAuthResponse(loginResposne);
                        getCandidateReviewDetails();
                      }
                    }
                  })
                  .catch((error) => {});
              });
          }
        });
      return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
    }
  }, []);

  const getCandidateReviewDetails = () => {
    ProfileService.getCandidateReview().then((response) => {
   if (APIResposneService.isProfileCompleted(response)) {
       StorageService.saveInLocalStorage(StorageValues.PROFILE, "completed");
      } else {
       StorageService.saveInLocalStorage(StorageValues.PROFILE, "notcompleted");
      }
      window.location.href = "/";
    });
  };

  const submitButton = (reqObj) => {
    let phoneNumber = "";
    let phoneNo = reqObj.phoneNumber;
    let countryCode = reqObj.countryCode;

    if (!Stringutility.isNullOrEmpty(phoneNo)) {
      if (!Stringutility.isNullOrEmpty(countryCode)) {
        phoneNumber = countryCode + "-" + phoneNo;
      }
    } else {
      phoneNumber = phoneNo;
    }
    const signUpReqest = {
      firstName: Stringutility.getValue(reqObj.firstName),
      lastName: Stringutility.getValue(reqObj.lastName),
      email: Stringutility.getValue(reqObj.email),
      contactNumber: phoneNumber,
      acceptTac: accept_terms_and_conditions,
      acceptPrivacyPol: accept_privacy_policy,
    };
    saveUserDetails(signUpReqest).then((response) => {
      try {
        if (response.message != null) {
        } else {
          userLogin();
        }
      } catch (err) {}
    });
  };

  const userLogin = () => {
    candidateLogin().then((response) => {
      try {
        if (response.data !== undefined && response.data !== "") {
          const loginResposne = response.data;
          APIResposneService.saveLoginAuthResponse(loginResposne);
          getCandidateReviewDetails();
        }
      } catch (err) {}
    });
  };

  let count = 0;
  useEffect(() => {}, [count]);

  return (
    <>
      <div className="login-page home-text padding-bottom ">
        {Stringutility.isNullOrEmpty(window.sessionStorage.getItem("jobId")) && <Header />}
        <div className="registerpage-login-name">Login</div>
        <StyledFirebaseAuth
          uiConfig={uiConfig}
          firebaseAuth={firebase.auth()}
        />
      </div>
    </>
  );
};

export default Firebaselogin;
